import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetTransportQuery,
  usePublicGetTransportQuery,
  useGetTransportEntriesQuery,
  usePublicGetTransportEntriesQuery,
  useGetTransportEntriesDefaultsQuery,
  usePublicGetTransportEntriesDefaultsQuery,
  useUpdateTransportsMutation,
  useCreateTransportEntryMutation,
  useUpdateTransportEntryMutation,
  useDeleteTransportEntryMutation
} from '../features/modules/transportApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting transport data based on the current route.
 */
export const useContextAwareGetTransport = createContextAwareHook(
  useGetTransportQuery,
  usePublicGetTransportQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting transport entries based on the current route.
 */
export const useContextAwareGetTransportEntries = createContextAwareHook(
  useGetTransportEntriesQuery,
  usePublicGetTransportEntriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting transport entries defaults based on the current route.
 */
export const useContextAwareGetTransportEntriesDefaults = createContextAwareHook(
  useGetTransportEntriesDefaultsQuery,
  usePublicGetTransportEntriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateTransportsMutation,
  useCreateTransportEntryMutation,
  useUpdateTransportEntryMutation,
  useDeleteTransportEntryMutation
}; 